import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DisconnectStripeMutation } from "../graphql/mutations";
import type {
  DisconnectStripeMutationType,
  DisconnectStripeMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDisconnectStripeMutation = (
  options?: MutationHookOptions<
    DisconnectStripeMutationType,
    DisconnectStripeMutationVariablesType
  >
) => {
  return useMutation<
    DisconnectStripeMutationType,
    DisconnectStripeMutationVariablesType
  >(DisconnectStripeMutation, options);
};
